import * as React from "react";
import { Container, Grid, Paper } from "@material-ui/core";
import { useState } from "react";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import NffReportFilter from "./NffReportFilter";
import NffReportList from "./NffReportList";
import MonthlyNffTrend from "./MonthlyNffTrend";
import TotalNffRate from "./TotalNffRate";

const NffReport = props => {
  const { user } = useAuth();

  const getDefaultCustomerCode = () => {
    if (!user?.isCustomer) return [];
    const code = user?.customerCode?.includes("-O") ? user?.relatedCustomerCode : user?.customerCode;
    return code ? [code] : [];
  };

  const getDefaultDates = () => {
    const now = new Date();
    const toYear = now.getFullYear();
    const toMonth = now.getMonth() + 1;
    let fromMonth = toMonth - 3;
    let fromYear = toYear;
    if (fromMonth <= 0) {
      fromMonth += 12;
      fromYear -= 1;
    }
    const pad = (n: number) => String(n).padStart(2, "0");
    return {
      startDate: `${fromYear}-${pad(fromMonth)}-01`,
      endDate: `${toYear}-${pad(toMonth)}-01`,
    };
  };

  const [filterParams, setFilterParams] = useState({
    customer__in: getDefaultCustomerCode(),
    ...getDefaultDates(),
  });

  const CreateFilter = filterParams => {
    var filter: any = {
      searchDate__gte: filterParams.startDate,
      searchDate__lte: filterParams.endDate,
    };

    if (filterParams?.fleetType__in?.length > 0) {
      filter = { ...filter, fleetType__in: filterParams.fleetType__in };
    }

    // Handle customer__in from the filter form
    if (filterParams?.customer__in?.length > 0) {
      filter = { ...filter, customer__in: filterParams.customer__in };
    }

    // Always enforce customer filter for customer users
    if (user?.isCustomer) {
      const customerCode = user?.customerCode?.includes("-O") ? user?.relatedCustomerCode : user?.customerCode;
      if (customerCode) {
        filter = { ...filter, customer__in: [customerCode] };
      }
    }

    return filter;
  };

  return (
    <>
      <NffReportFilter
        filterParams={filterParams}
        setFilterParams={params => {
          setFilterParams(params);
        }}
        user={user}
      />
      <>
        <br />
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12} md={5}>
              <Paper variant="outlined" style={{ height: "100%" }}>
                <TotalNffRate filterParams={CreateFilter(filterParams)} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={7}>
              <Paper variant="outlined" style={{ height: "100%" }}>
                <MonthlyNffTrend filterParams={CreateFilter(filterParams)} />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </>

      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <NffReportList basePath="reliabilitynffreports" filterParams={CreateFilter(filterParams)} {...props} />
        </Paper>
      </Container>
    </>
  );
};

export default NffReport;
